import React from "react";
import "./Spinner.css";

const Spinner = () => (
  <div className="spinner-overlay">
    <div className="spinner-container"></div>
  </div>
);

export default Spinner;